import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormCheckbox,
  title: 'Checkbox',
  category: ComponentCategory.FormControls,
};
